import React, { useState } from 'react';
import { CreateFeatureDialog } from '../../../../components';
import { DICTIONARY_PATHS } from '../../../../constants/dictionary-paths';
import { usePermission } from '../../../../core';
import { Feature } from '../../../../lib';
import { useNavigate } from 'react-router-dom';
import { dictionaryMenuItems } from './create-dictionary-view-helper';

export const CreateDictionaryView = (): React.JSX.Element => {
    const [selectedOption, setSelectedOption] = useState<string>(
        DICTIONARY_PATHS.CREATE_NEW_DICTIONARY
    );
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();

    const handleNoFeatureCreationPermission = (): void => {
        setDisplayPermissionDialog(true);
    };

    const handleNext = (): void => {
        const feature: Feature =
            selectedOption === DICTIONARY_PATHS.CREATE_NEW_DICTIONARY
                ? 'dictionary-editor'
                : 'job-manager';
        const featureIsJobManager: boolean = feature === 'job-manager';
        const hasFeaturePermission = hasPermissions('createMetadata');

        /**
         * if user has permission and is navigating to job manager, ensure that we
         * can go back to the dictionaries create view via URL search params.
         */
        if (hasFeaturePermission && featureIsJobManager) {
            const url = new URL(window.location.origin + selectedOption);
            url.searchParams.set(
                'create-dictionary-view',
                DICTIONARY_PATHS.CREATE_NEW_DICTIONARY_VIEW
            );

            navigate(url.pathname + url.search, { replace: true });
        } else if (hasFeaturePermission && !featureIsJobManager) {
            // no need to set url search params since we are landing at dictionary update page.
            navigate(selectedOption);
        } else {
            handleNoFeatureCreationPermission();
        }
    };

    const handleClose = (): void => {
        navigate(DICTIONARY_PATHS.LANDING_PAGE);
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <CreateFeatureDialog
            items={dictionaryMenuItems}
            selectedOption={selectedOption}
            handleClose={handleClose}
            handleNext={handleNext}
            displayPermissionDialog={displayPermissionDialog}
            setSelectedOption={setSelectedOption}
            handlePermissionDialogClose={handlePermissionDialogClose}
            headingText={'What would you like to do?'}
        />
    );
};
